import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../../service/utils.service';
import { utils } from 'protractor';

@Pipe({
    name: 'icon'
})
export class IconPipe implements PipeTransform {
    constructor(private utils: UtilsService) { }
    transform(value: string): string {
        return this.utils.extractIcon(value);
    }
}

@Pipe({
    name: 'designation'
})
export class DesignationPipe implements PipeTransform {
    constructor(private utils: UtilsService) { }
    transform(value: string): string {
        return this.utils.extractDesignation (value);
    }
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/shared/pipes/common.pipe.ts